//ClientPage.js
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import GlobalError from '../components/GlobalError';
import { useSnackbar } from '../contexts/SnackbarProvider';
import useDataFetch from '../hooks/useDataFetch';
import { getFields, searchFields } from '../utils/fields';
import SearchForm from '../components/SearchForm';
import TableView from '../components/TableView';
import Pagination from '../components/Pagination';
import RelatedMenu from '../components/RelatedMenu';
import { Chip, Button, Link, Typography, Paper } from "@mui/material";

const ClientsPage = (hasLimit = { hasLimit }) => {
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const initialFilters = {
    is_pending: location.state?.is_pending ?? false,
    client_code: '',
    company_name: '',
  };

  const {
    dataset,
    error,
    currentPage,
    totalPages,
    searchQuery,
    handleSearchChange,
    handleSearchSubmit,
    handleClearSearch,
    handlePageChange,
  } = useDataFetch('/client', initialFilters);

  // 行クリック時にページ遷移を行う処理
  const handleRowClick = (item) => {
    navigate(`/clients/${item.client_id}`);
  };

  // 検索フィールド定義
  const fieldsToInclude = ['is_pending', 'client_code', 'client_name'];
  let searchItems = getFields(searchFields, fieldsToInclude);

  //テーブルカラム
  const columns = [
    {
      label: '取引先コード',
      accessor: 'client_code',
      render: (item) => (
        <Link
          onClick={() => handleRowClick(item)}>
          {item.client_code}
        </Link>
      ),
      width: '100px',
    },
    {
      label: '会社名＋事業所名',
      accessor: 'client_name',
      render: (item) => (
        <Typography>
          {item.client_name} {item.branch_name}
        </Typography>
      ),
      width: '250px',
    },
    {
      label: 'ステータス',
      accessor: 'status',
      render: (item) => {
        const statusMap = {
          pending: { label: '申請中', color: 'warning' },
          active: { label: '有効', color: 'success' },
          invalid: { label: '無効', color: 'default' },
        };

        const status = statusMap[item.status] || { label: '不明', color: 'default' };

        return <Chip label={status.label} color={status.color} />;
      },
      width: '80px',
    },
    {
      label: '',
      render: (item) => (
        <Button
          size="small"
          variant="outlined"
          onClick={() => handleRowClick(item)}>
          詳細
        </Button>
      ),
      width: '64px',
    },
  ];
  useEffect(() => {
    const snackbarState = location.state?.snackbar;
    if (snackbarState) {
      showSnackbar(snackbarState.message, snackbarState.severity);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, navigate, showSnackbar]);
  const links = [
    { path: '/clients/new', label: '取引先登録', icon: 'person_add' },
  ];

  if (error) return <GlobalError errorMessage={error} />;
  return (
    <>
      <Typography variant="h1" component="h1">取引先一覧</Typography>
      <div className='grid2-2_1'>
        {/* 検索フォーム */}
        <SearchForm
          searchQuery={searchQuery}
          searchFields={searchItems}
          handleSearchChange={handleSearchChange}
          handleSearchSubmit={handleSearchSubmit}
          handleClearSearch={handleClearSearch}
        />
        <RelatedMenu links={links} />
      </div>
      <Paper variant='section'>
        {/* テーブル */}
        <TableView dataset={dataset} columns={columns} />
        {/* ページネーション */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </Paper>
    </ >
  );
};

export default ClientsPage;
